import { spawn } from 'redux-saga/effects';

import loadbalancer from './loadbalancer/sagas';
import utilSagas from './util/utilSagas';
import zoneSagas from './zone/zoneSagas';

export default function* networkSagas() {
	yield spawn(loadbalancer);
	yield spawn(utilSagas);
	yield spawn(zoneSagas);
}
